import { RSAA } from 'redux-api-middleware'
import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('FETCH_VIMEO_THUMBNAIL', 'vimeo'),
}

export const fetchVimeoThumbnail = ({ videoId, width = 640 }) => {
  return {
    [RSAA]: {
      // More about this endpoint at https://developer.vimeo.com/api/oembed/videos
      endpoint: `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${videoId}&format=json&width=${width}`,
      method: 'GET',
      types: [
        types.FETCH_VIMEO_THUMBNAIL_REQUEST,
        {
          type: types.FETCH_VIMEO_THUMBNAIL_SUCCESS,
          meta: { videoId },
        },
        types.FETCH_VIMEO_THUMBNAIL_ERROR,
      ],
      fetch: input => {
        return fetch(input, {
          mode: 'cors', // Ensures we don't get a CORS error
        })
      },
    },
  }
}

export const initialState = {
  vimeo: {
    busy: false,
    error: '',
    entities: {}, // keyed object map
  },
}

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.FETCH_VIMEO_THUMBNAIL_REQUEST: {
      return {
        ...state,
        vimeo: {
          ...state.vimeo,
          busy: true,
          error: '',
        },
      }
    }

    case types.FETCH_VIMEO_THUMBNAIL_SUCCESS: {
      return {
        ...state,
        vimeo: {
          ...state.vimeo,
          busy: false,
          entities: {
            ...state.vimeo.entities,
            [meta.videoId]: {
              ...state.vimeo.entities[meta.videoId],
              ...payload,
            },
          },
        },
      }
    }

    case types.FETCH_VIMEO_THUMBNAIL_ERROR: {
      return {
        ...state,
        vimeo: {
          ...state.vimeo,
          busy: false,
          error: payload.response,
        },
      }
    }

    default:
      return state
  }
}
